<template>
    <div>
        <!-- Transformação / Montagem / Fabricação  -->
        <div class="modal fade" id="montagemItemModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Montagem / Fabricação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    placeholder="Selecione o material..."
                                    label="Montar"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="estoque_items.index"
                                    :optionsSync="true"
                                    :optionsParm="{ kit_transform: true }"
                                    :edicao="!lista_items.length"
                                    required
                                    :validate="validate"
                                    v-model="item.item" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Quantidade"
                                    :edicao="!lista_items.length"
                                    required
                                    :validate="validate"
                                    v-model="item.qtde" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação"
                                    v-model="item.st_observacao" />
                            </div>
                        </div>

                        <template v-if="item.item">

                            <az-sub-title title="Insumos" class="mt-3" />
                            
                            <!-- Lista de Itens (Insumos) -->
                            <template v-for="(material, imx) in lista_items">
                                <div class="form-row" :key="imx" v-if="true">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            :edicao="false"
                                            v-model="material.item.search">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger btn-sm" type="button" id="button-addon1" @click="material.fl_ativo = false">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon2">#{{ material.item.id_estoque_item }}</span>
                                                    <button class="btn btn-outline-secondary btn-sm" type="button" id="button-addon2" 
                                                        v-if="material.item.fl_controla_lote && !material.lote && !( material && material.lotes && material.lotes.length )" 
                                                        title="Identificar Lote" 
                                                        @click="buscar_lotes(material)"
                                                        :disabled="material.item && material.item.lote && material.item.lote.loading">

                                                        <div class="spinner-grow spinner-grow-sm" role="status" v-if="material.item && material.item.lote && material.item.lote.loading">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>

                                                        <i class="fa-solid fa-l" v-else></i>

                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                        <div class="mb-2" v-if="material.lote">
                                            <small class="text-muted ml-3">
                                                Lote: {{ material.lote.st_lote }} / Validade: {{ $util.getFormatDate(material.lote.dt_validade) }}
                                            </small>
                                        </div>

                                        <div class="mb-2" v-else-if="material.item.fl_controla_lote && ( material && material.lotes && material.lotes.length )">
                                            <ul class="list-group mb-2" v-if="material && material.lotes && material.lotes.length">
                                                <li class="list-group-item d-flex justify-content-between" v-for="(item_lote, ilx) in material.lotes" :key="ilx">
                                                    <div>
                                                        <a href="#" @click.prevent="selecionar_lote_lista(material, item_lote)">{{ item_lote.search }}</a>

                                                        <span v-if="item_lote.fl_consig" class="small text-muted ml-2">
                                                            (Consig)
                                                            <span v-if="item_lote.fornecedor">
                                                                {{ item_lote.fornecedor.search }}
                                                            </span>
                                                            <span v-else-if="item_lote.id_fornecedor">
                                                                Forn: #{{ item_lote.id_fornecedor }}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span class="mr-2">{{ item_lote.saldo.qtd }}</span>
                                                        <i class="fas fa-boxes mr-5"></i>
                                                        
                                                        <span class="mr-2">{{ $util.getFormatDate(item_lote.dt_validade) }}</span>
                                                        <i class="fas fa-hourglass-end"></i>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            type="number"
                                            required 
                                            :validate="validate"
                                            v-model="material.in_quantidade">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <span class="input-group-text small" id="basic-addon2">
                                                        {{ material.item.st_unidade_estoque }}    
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Observação..."
                                            v-model="material.st_observacao">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="material.saldo">
                                                    <span class="input-group-text small" id="basic-addon2" title="Saldo">
                                                        <div class="spinner-grow spinner-grow-sm" role="status" v-if="material.saldo.loading">
                                                        <span class="sr-only">Loading...</span>
                                                        </div>
                                                        <template v-else>
                                                            S: {{ material.saldo.qtd }} 
                                                            <span class="ml-1" v-if="material.reservado > 0">
                                                                / R: {{ material.reservado }}
                                                            </span>

                                                            <i class="fa fa-exclamation-triangle text-danger ml-2" v-if="( material.saldo && !material.saldo.loading && material.saldo.qtd === 0 )" aria-hidden="true" title="Saldo Indisponível."></i>
                                                            <i class="fa fa-exclamation-triangle text-warning ml-2" v-else-if="( material.saldo && !material.saldo.loading && material.saldo.qtd < material.in_quantidade )" aria-hidden="true" title="Saldo Insuficiente."></i>
                                                            <i class="fa fa-exclamation-triangle text-info ml-2" v-else-if="( material.saldo && !material.saldo.loading && material.saldo.qtd < material.in_quantidade + material.reservado )" aria-hidden="true" title="Saldo com reservas insuficiente."></i>
                                                        </template>
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>
                            </template>
                            
                            <selecao-material 
                                ref="selecmat" 
                                @selecionado="incluir_item" 
                                :id_estoque_local="item.id_estoque_local" 
                                :infoqt="true" 
                                :blocklote="item.qtde > 1 || ( item.item && !item.item.fl_controla_lote )"
                                :kits="true" />

                        </template>

                        <br><br><br><br><br><br><br><br>
                    </div>

                    <div class="modal-footer d-flex justify-content-between flex-column flex-md-row">
                        <div>
                            <az-input
                                type="checkbox-group"
                                label="Imprimir Etiqueta"
                                v-model="imprimir_etiqueta" />
                        </div>
                        <div>
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">Cancelar</button>
                            <az-submit @click="atualizar()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <estoque-etiqueta ref="estoque_etiqueta" />
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import SelecaoMaterial from './SelecaoMaterial.vue';
import EstoqueEtiqueta from './EstoqueEtiqueta.vue';

export default { 
    data() {
        return { 
            item: { 
                item: null, 
                qtde: 1, 
                id_estoque_local: "", 
                items: [], 
                st_observacao: "", 
            },
            validate: false, 
            na_baixa: true, 
            imprimir_etiqueta: true, 
        }
    },

    components: { 
        AzSubmit,
        AzInput, 
        AzSubTitle, 
        SelecaoMaterial, 
        EstoqueEtiqueta,
    },

    computed: { 
        lista_items: function () { 
            if ( !this.item )
                return [];

            return this.item.items.filter(item => item.fl_ativo);
        },
    }, 

    methods: { 
        selecionar_lote_lista (material, item_lote) { 
            material.lote = _.cloneDeep(item_lote);
        },
        
        buscar_lotes(item) { 
            if ( item && item.item && !item.item.lote ) { 
                item.item.lote = { 
                    numero: "", 
                    validade: "", 
                    item: "", 
                    loading: "", 
                };

                this.$forceUpdate();
            }

            if ( !item || !item.item || !item.item.lote )
                return;

            item.item.lote.loading = true;

            this.$util.loadItem(this, { 
                service: "estoque_lotes",
                func: 'index',
                parms: { 
                    id_estoque_item: item.item.id_estoque_item, 
                    id_estoque_local: this.item.id_estoque_local,
                    saldos: true, 
                }
            })
            .then(res => { 
                console.log(res);

                item.lotes = _.orderBy(
                    res.filter(item => item.saldo && item.saldo.qtd > 0),
                    'dt_validade'
                );

                this.$forceUpdate();
            })
            .finally(() => { 
                item.item.lote.loading = false;
            });
        },

        abrir(id_estoque_local) { 
            this.validate = false;

            this.item = { 
                item: null, 
                qtde: 1, 
                id_estoque_local: id_estoque_local, 
                items: [],
                st_observacao: "", 
            };

            $('#montagemItemModal').modal('show');
        }, 

        atualizar () { 
            this.$util.atualizar(this, {  
                service: 'estoque',
                func: 'transformar', 
                modal: 'montagemItemModal', 
                dados: { 
                    id_estoque_local: this.item.id_estoque_local,
                    id_estoque_item: this.item.item ? this.item.item.id_estoque_item : null, 
                    qtde_prod: this.item.qtde,
                    montagem: true,
                    st_observacao: this.item.st_observacao, 
                    aprs: this.lista_items.map(item => { 
                        return { 
                            id_estoque_item: item.item.id_estoque_item, 
                            qt_uso: item.in_quantidade, 
                            st_observacao: item.st_observacao, 
                            fl_ativo: item.fl_ativo, 
                            lote: item.lote ? item.lote.id_estoque_lote : null, 
                            st_lote: item.lote ? item.lote.st_lote : null,
                        }
                    }),
                },
                callback: res => { 
                    this.$emit('refresh');

                    if ( this.imprimir_etiqueta ) { 
                        this.$nextTick(() => { 
                            this.emitir_etiqueta(res);
                        });
                    }
                }
            });
        }, 

        incluir_item(novo) { 
            if ( !novo )
                return;

            let busca = this.item.items.find(item => item.fl_ativo 
                && item.item.id_estoque_item == novo.id_estoque_item
                && ( !_.get(novo, 'lote.item') || _.get(item, 'lote.st_lote') == _.get(novo, 'lote.item.st_lote') ) );

            if ( busca ) { 
                busca.in_quantidade = parseInt(busca.in_quantidade) + parseInt( novo.quantidade ? novo.quantidade : 1 );
                return; 
            }

            let novoitem = { 
                id_estoque_solicitacao: this.item.id_estoque_solicitacao, 
                id_estoque_item: null, 
                id_estoque_item_kit: novo.id_estoque_item_kit, 
                item: novo, 
                in_quantidade: novo.quantidade ? novo.quantidade : 1,
                id_receita_medicamento: novo.id_receita_medicamento ? novo.id_receita_medicamento : null,
                fl_pendente: true, 
                st_observacao: "", 
                fl_ativo: true, 
                lote: _.get(novo, 'lote.item'), 
            };

            if ( !this.item.fl_estorno && this.na_baixa ) { 
                novoitem.saldo = { 
                    loading: true,
                };
            }

            this.item.items.push(novoitem);

            if ( novoitem && novoitem.saldo ) {  

                this.$util.loadItem(this, { 
                    service: "estoque_items",
                    id: novo.id_estoque_item, 
                    parms: { 
                        saldos: true, 
                        id_estoque_local: this.item.id_estoque_local,
                        num_lote: _.get(novo, 'lote.item.st_lote'), 
                        reservas: true, 
                        componentes: true, 
                    }
                })
                .then(res => { 
                    if ( !res.saldo ) { 
                        novoitem.saldo = { 
                            qtd: 0, 
                        };
                        novoitem.reservado = 0;
                    } else { 
                        novoitem.saldo = res.saldo;
                        novoitem.reservado = res.reservado ? res.reservado : 0;
                    }
                    
                    this.$forceUpdate();
                });
                
            } else if ( !this.item.fl_estorno && novo.componentes_count ) { 

                this.$util.loadItem(this, { 
                    service: "estoque_items",
                    id: novo.id_estoque_item, 
                    parms: { 
                        id_estoque_local: this.item.id_estoque_local,
                        componentes: true,
                    }
                })
                .then(res => {
                    if ( res.componentes && res.componentes.length ) { 
                        res.componentes.map(comp => { 
                            return { 
                                ...comp.item, 
                                quantidade: comp.in_quantidade * ( comp.in_para_cada ? Math.ceil ( novoitem.in_quantidade / ( comp.in_para_cada > 0 ? comp.in_para_cada : 1 ) ) : 1 ),
                            }
                        })
                        .forEach(comp => { 
                            this.incluir_item(comp);
                        });
                    }
                });

            }

            /*
            this.$nextTick(() => { 
                this.novoItem = "";
            });
            */
        },

        emitir_etiqueta(mov) {
            if ( mov.mov ) { 

                const etiquetaItens = {
                    checked: true,
                    id_estoque_item: mov.mov.id_estoque_item,
                    lote: mov.mov.st_lote,
                    validade: mov.mov.dt_validade,
                    qtde: 1,
                    search: 'Item',
                };

                this.$refs.estoque_etiqueta.show([etiquetaItens]);

            }
        },

    }
}
</script>
